<template>
	<v-alert
		:value="true"
		:type="type || null"
		:color="color"
		:id="id"
		class="elevation-12 toast-item py-2 px-1">

		<v-progress-circular
			v-if="timeout"
			absolute right
			color="black"
			:size="36"
			:width="4"
      :rotate="-90"
			class="btn-progress"
			:value="progress">
			<v-btn
				small icon flat
				color="black"
				@click="clear()">
				<v-icon>cancel</v-icon>
			</v-btn>
		</v-progress-circular>
		<v-btn
			v-else
			small icon flat
			absolute right
			color="black"
			@click="clear()">
			<v-icon>cancel</v-icon>
		</v-btn>

		<div class="title mb-2 mr-5 ml-2">{{ title }}</div>
		<div v-safe-html.allowLinks="content"></div>

		<v-progress-linear
			v-if="loading"
			color="black"
			:height="2"
			:indeterminate="true">
		</v-progress-linear>

		<v-progress-linear
			v-else-if="timeout"
			color="black"
			:height="2"
			:value="progress">
		</v-progress-linear>
	</v-alert>
</template>

<script>
export default {
	props: [ 'type', 'title', 'content', 'loading', 'timeout', 'id' ],
	data () {
		return {
			timeout_var: null,
			interval: null,
			progress: 0
		}
	},
	computed: {
		color () {
			if (this.type === 'info') return 'light-blue accent-3 black--text'
			if (this.type === 'success') return 'green accent-3 black--text'
			if (this.type === 'warning') return 'orange accent-2 black--text'
			if (this.type === 'error') return 'red accent-2 black--text'
			return 'primary black--text'
		}
	},
	methods: {
		clear () {
			this.$emit('clear', this.id)
		},
		onInterval () {
			if (this.progress === 100) {
				clearInterval(this.interval)
				setTimeout(this.clear, 500)
			} else {
				this.progress += 2
			}
		}
	},
	mounted () {
		if (this.timeout) {
			let interval = this.timeout / 50
			this.interval = setInterval(this.onInterval, interval)
		}
	},
	beforeDestroy () {
		clearInterval(this.interval)
	}
}
</script>

<style lang="stylus" scoped>
.v-alert
	margin-left: 12px
	margin-bottom: 12px
	margin-top: 12px
	width: 450px
	border-radius 4px
	pointer-events: auto
	overflow-wrap: anywhere
	>>>.v-icon
	>>>a
		color: black
	>>>.v-alert__icon
		font-size: 32px
		margin-right: 8px

.btn-progress
	position: absolute
	right: 4px
	top: 4px

.v-progress-linear
	position: absolute
	top: -15px
	left: 2px
	width: 99%
</style>



// WEBPACK FOOTER //
// src/App_toaster_item.vue